import { createFileRoute } from "@tanstack/react-router";
import { PackagesPage } from "@/components/dashboard/packages-page";

export const Route = createFileRoute("/packages")({
  head: () => ({
    meta: [
      { title: "Packages — Deuxda Admin" },
      { name: "description", content: "Manage the diamond packages sold in the app." },
    ],
  }),
  component: () => <PackagesPage />,
});
